import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import withRouter from './withRouter';
import { logoutUser } from '../slices/thunks';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';


const ProfileDropdown = (props) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state?.user?.currentUser);
    const { t } = useTranslation();


    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogout = () => {
        dispatch(logoutUser(props.router.navigate));
    }
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none" >
                    <span className="d-flex align-items-center">
                        <i className="mdi mdi-account-circle text-muted fs-1 align-middle"></i>
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user?.username}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                    <h6 className="dropdown-header pb-0">{user?.username}</h6>
                    <p className="dropdown-header pt-0">{user?.przedstawiciel}</p>
                    <p className="dropdown-header pt-0">SID: {user?.gr_id_kth}</p>
                    <DropdownItem onClick={() => { props.router.navigate('/profile') }}><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">{t('nav.profile')}</span></DropdownItem>
                    {user?.role !== "subaccount" && (user?.role === "admin" || (user?.permissions && user.permissions.includes("subaccounts"))) &&
                        <DropdownItem onClick={() => { props.router.navigate('/profile/subaccounts') }}><i className="mdi mdi-account-supervisor-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">{t('nav.subaccounts')}</span></DropdownItem>
                    }
                    <div className="dropdown-divider"></div>
                    <DropdownItem onClick={handleLogout}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">{t('nav.logout')}</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default withRouter(ProfileDropdown);
